import { getOrCreateProfileV2, useGetOrCreateProfileV2 } from '@ping/api';
import {
  complianceStepSelector,
  userInformationStore,
  useUserInformationStore,
  withBusinessProfileFields,
} from '@ping/stores/userInformation.store';
import { UseQueryOptions } from 'react-query';

export const useProfile = (queryOptions?: UseQueryOptions<Awaited<ReturnType<typeof getOrCreateProfileV2>>>) => {
  const complianceStep = useUserInformationStore(complianceStepSelector);
  const { data, ...rest } = useGetOrCreateProfileV2(
    {},
    {
      query: {
        ...queryOptions,
        queryKey: ['profile-information', complianceStep],
        onSuccess: data => {
          userInformationStore.setUserInformation(withBusinessProfileFields(data));
        },
      },
    }
  );

  return {
    data,
    ...rest,
  };
};
